import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/de';

class MomentDate extends Component {
  render() {
    let { date, format } = this.props;
    moment.locale('de');

    if (format === undefined) {
      format = "DD. MMMM YYYY";
    }

    const dateString = moment(date).format(format);

    return (
      <div>
        {dateString}
      </div>
    );
  }
}

MomentDate.propTypes = {
  date: PropTypes.string.isRequired,
  format: PropTypes.string
}

export default MomentDate;



// WEBPACK FOOTER //
// ./src/components/date/date.jsx